import { useEffect, useState, useContext } from "react"; // Import useContext
import GalleryItem from "../components/GalleryItem";
import ImageModal from "../components/ImageModal";
import "./Gallery.css";
import { Typography } from "@mui/material";
import { LanguageContext } from "../context/LanguageContext"; // Import LanguageContext

const Gallery = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  const { language } = useContext(LanguageContext); // Consume LanguageContext

  // Translatable content for the Gallery page
  const enContent = {
    galleryTitle: "GALLERY",
  };

  const urContent = {
    galleryTitle: "گیلری", // Urdu for GALLERY
  };

  const content = language === "en" ? enContent : urContent;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/posts`);
        const data = await response.json();

        const formatted = data.flatMap((post) =>
          post.imageUrls.map((url, index) => ({
            id: `${post._id}-${index}`,
            title: post.title,       // Assuming post titles/descriptions are in a single language
            description: post.subtitle, // and will not be directly translated here
            image: url,
          }))
        );

        setGalleryItems(formatted);
      } catch (error) {
        console.error("Error fetching gallery items:", error);
      }
    };

    fetchPosts();
  }, []);

  const handleImageClick = (item) => {
    setSelectedImage(item);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <div>
        <Typography
        data-tts="true"
          variant="h2"
          fontWeight="bold"
          gutterBottom
          textAlign={"center"}
          marginTop={5}
          color="black"
        >
          {content.galleryTitle} {/* Render translated title */}
        </Typography>
      </div>

      <div className="gallery-wrapper">
        <div className="gallery-grid">
          {galleryItems.map((item) => (
            <GalleryItem
              key={item.id}
              item={item}
              onClick={() => handleImageClick(item)}
            />
          ))}
        </div>
      </div>

      {selectedImage && (
        <ImageModal item={selectedImage} onClose={handleCloseModal} />
      )}
    </>
  );
};

export default Gallery;